<template>
    <v-card raised color="grey darken-2">
        <v-card-text>

            <pie-chart
                    :data="chartData"
                    valuesTitle="Percent"
                    :title="dataVariable.name"
            ></pie-chart>

        </v-card-text>
    </v-card>
</template>

<script>

    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import ColumnChart from '../../../../components/charts/ColumnChart';
    import PieChart from '../../../../components/charts/PieChart';

    export default {

        components: {
            ColumnChart,
            PieChart,
        },

        props: {
            dataVariable: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                statsLoading: false,
                chartData: []
            }
        },

        mounted() {

            this.statsLoading = true;

            this.getDataVariableStats(this.dataVariable.id)
                .then(data => {
                    this.prepareChartData(data.stats);
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Failed loading stored data count for the option!'
                    });
                })
                .finally(() => {
                    this.statsLoading = false;
                });
        },

        methods: {

            // Root actions
            ...mapActions([
                'getDataVariableStats'
            ]),

            prepareChartData(data) {

                this.chartData = data.map(item => {

                    return {label: item.country + ' - ' + item.language, value: item.count, percent: item.percent}
                });
            }

        }
    }
</script>
